import { render } from "./BasicToggle.vue?vue&type=template&id=348c4e0c&scoped=true&ts=true"
import script from "./BasicToggle.vue?vue&type=script&lang=ts"
export * from "./BasicToggle.vue?vue&type=script&lang=ts"

import "./BasicToggle.vue?vue&type=style&index=0&id=348c4e0c&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348c4e0c"]])

export default __exports__